export type DonViTien = 'USD' | 'VND';

const DINH_DANG: Record<DonViTien, Intl.NumberFormat> = {
  USD: new Intl.NumberFormat('vi-VN', {
    style: 'currency',
    currency: 'USD',
    // Không dùng "US$" cho gọn bảng.
    currencyDisplay: 'narrowSymbol',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }),
  VND: new Intl.NumberFormat('vi-VN', {
    style: 'currency',
    currency: 'VND',
    maximumFractionDigits: 0,
  }),
};

export function dinhDangTien(giaTri: number | string, currency: DonViTien = 'USD'): string {
  const so = typeof giaTri === 'string' ? Number(giaTri) : giaTri;
  if (!Number.isFinite(so)) return '—';
  return DINH_DANG[currency].format(so);
}

/**
 * `3120 → "$3,1K"`. Dùng cho nhãn trên đầu cột biểu đồ, nơi không đủ chỗ cho
 * số đầy đủ. Ký hiệu đặt trước số theo đúng ảnh thiết kế.
 */
export function dinhDangTienGon(giaTri: number | string | null | undefined): string {
  const so = typeof giaTri === 'string' ? Number(giaTri) : (giaTri ?? Number.NaN);
  if (!Number.isFinite(so)) return '—';
  if (Math.abs(so) >= 1000) return `$${(so / 1000).toFixed(1).replace('.', ',')}K`;
  return `$${String(Math.round(so))}`;
}

/**
 * `1.32 → "$1,32"`. RPM trong ảnh thiết kế đặt ký hiệu trước số.
 * Đơn vị khác `USD` thì bỏ ký hiệu (chưa có thiết kế cho trường hợp đó).
 */
export function dinhDangRpm(giaTri: number | string | null | undefined, currency = 'USD'): string {
  const so = typeof giaTri === 'string' ? Number(giaTri) : (giaTri ?? Number.NaN);
  if (!Number.isFinite(so)) return '—';
  const ky = currency === 'USD' ? '$' : '';
  return `${ky}${so.toFixed(2).replace('.', ',')}`;
}

export interface MoneyProps {
  /** Tiền lưu bằng Decimal nên API trả về chuỗi; nhận cả hai kiểu. */
  value: number | string | null | undefined;
  currency?: DonViTien;
  className?: string;
}

export function Money({ value, currency = 'USD', className = '' }: MoneyProps) {
  if (value === null || value === undefined || value === '') {
    return <span className={`text-chu-mo ${className}`}>—</span>;
  }
  return <span className={`so-lieu ${className}`}>{dinhDangTien(value, currency)}</span>;
}
